import { render, staticRenderFns } from "./TabFirstPerson.vue?vue&type=template&id=f8900b86&scoped=true&"
import script from "./TabFirstPerson.vue?vue&type=script&lang=ts&"
export * from "./TabFirstPerson.vue?vue&type=script&lang=ts&"
import style0 from "./TabFirstPerson.vue?vue&type=style&index=0&id=f8900b86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8900b86",
  null
  
)

export default component.exports